import { useContext } from 'react';
import { useIsAuthenticated } from '@azure/msal-react';
import CreateImg from './assets/create.png';
import HomeImg from './assets/home.png';
import ManageImg from './assets/manage.svg';
import PaymentsImg from './assets/payments.png';
import ProjectsImg from './assets/wall.svg';
import HomeGrayImg from './assets/home-gray.png';
import Styles from './Links.module.css';
import { UserContext } from '../../context/User';
import useProjectSteps from '../../hooks/useProjectSteps';
import { APPConstants } from '../../constants/app';

function Links() {
  const isAuthenticated = useIsAuthenticated();
  const projectSteps = useProjectSteps();
  const { isHomeowner, isContractor } = useContext(UserContext);

  return [
    {
      icon: !isAuthenticated || isHomeowner() ? HomeImg : HomeGrayImg,
      caption: 'Home',
      href: !isAuthenticated || isHomeowner() ? APPConstants.APP_BASE_URI : null
    },
    {
      icon: ProjectsImg,
      caption: 'Projects',
      href: isAuthenticated && isHomeowner() 
        ? '/solution'
        : (isAuthenticated && isContractor() ? '/my-work' : null),
      figureClassName: isAuthenticated ? Styles.projectsActive : null
    },
    {
      icon: CreateImg,
      caption: 'Create',
      figureClassName: Styles.createFigure + (isAuthenticated && isContractor() ? ` ${Styles.hidden}` : ''),
      href: !isAuthenticated || isHomeowner() ? projectSteps.getFirstStepPath() : null
    },
    {
      icon: PaymentsImg,
      caption: 'Payments'
    },
    {
      icon: ManageImg,
      caption: 'Profile',
      href: isAuthenticated ? '/my-profile' : null,
      figureClassName: isAuthenticated ? Styles.projectsActive : null
    },
  ];
}

export default Links;
